import { TweenMax } from 'gsap/all';

function Video() {
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/player_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);


    var player;
    function onYouTubePlayerAPIReady() {
        player = new YT.Player('ytplayer', {
            height: '360',
            width: '640',
            videoId: 'TUa30AAgjk4'
        });
    }
}

export default Video;



// WEBPACK FOOTER //
// ./resources/js/components/Video.js